import {PageCard} from '../../../../layout/page-card/page-card';
import {Spinner} from '../../../../layout/spinner/spinner';
import {useCatalog} from '../../../../provider/catalogs/catalogs-hook';
import {ProvidersIdsEnum} from '../../../../util/type';

import {AccountLinkingGoogle} from './account-linking-google';

export function AccountLinkingGoogleCard(): JSX.Element {
    const {catalog, isLoading} = useCatalog(ProvidersIdsEnum.google);

    return (
        <PageCard title={catalog?.name || ''}>
            {catalog && <AccountLinkingGoogle catalogInfo={catalog} />}
            {isLoading && <Spinner />}
        </PageCard>
    );
}
